import { useToggle } from "../../../../utils/Hooks"
import { FleLayout } from "../FleLayout"
import { BackArrow, SkipArrow, SwitchH2ToBodyLarge } from "../Molecules"
import { FleLinkWrapper, InfoCircle } from "../../atoms/Links"
import { Spacer } from "../../atoms/Atoms"
import SexChoices from "../../../../content/SexChoices"
import { Button } from "../../atoms/buttons/Button"
import FLEInformationModal from "components/views/modal/FLEInformationModal"
import React from "react"
import L10n from "../../../../lib/carrot-l10n"
import { TopSection } from "../TopSection"
import { useSelector } from "react-redux"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"
import { FeatureGate } from "utils/FeatureGate"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYouSex = ({ sex, updateSex, onSkip }) => {
  const [showMemberSexModal, toggleMemberSexModal] = useToggle(false)
  const benefitConfiguration = useSelector(getBenefitConfiguration)

  return (
    <FleLayout>
      <TopSection progressStep={2} leftOrBackArrow={<BackArrow />} />
      <div className="flex flex-row items-center">
        <SwitchH2ToBodyLarge>{l`What's your sex?`}</SwitchH2ToBodyLarge>
        <FeatureGate filter={(c) => c.isLgtbqEnabled}>
          <InfoCircle onClick={toggleMemberSexModal} />
        </FeatureGate>
      </div>
      <Spacer height={3} />
      {SexChoices.map(({ id, label }) => (
        <div key={id} className="flex flex-row justify-end w-100 mb1">
          <Button outline={id === sex} bold={false} onClick={() => updateSex(id)}>
            {label}
          </Button>
        </div>
      ))}
      <FleLinkWrapper>
        <SkipArrow onClick={onSkip} onClickOnly />
      </FleLinkWrapper>
      {showMemberSexModal ? (
        <FLEInformationModal
          benefitConfiguration={benefitConfiguration}
          onClose={toggleMemberSexModal}
          header={l`fle2.aboutyou.sex`}
          source={l`fle2.memberSexFull`}
        />
      ) : null}
    </FleLayout>
  )
}

export { AboutYouSex }
